var axios = require('axios');
var mapDataToFormData = function (data, formData) {
    if (formData === void 0) { formData = null; }
    if (!formData) {
        formData = new FormData();
    }
    Object.keys(data).forEach(function (key) {
        formData.append(key, data[key]);
    });
    return formData;
};
export var submitColumnSettings = function (data) {
    return axios.post(ajaxurl, mapDataToFormData({
        action: 'ac-columns',
        id: 'save',
        _ajax_nonce: AC._ajax_nonce,
        data: JSON.stringify(data)
    }));
};
export var switchColumnType = function (type, list_screen) {
    if (list_screen === void 0) { list_screen = AC.list_screen; }
    return axios.post(ajaxurl, mapDataToFormData({
        _ajax_nonce: AC._ajax_nonce,
        action: 'ac-columns',
        current_original_columns: JSON.stringify(AdminColumns.Form.getOriginalColumns().map(function (e) { return e.getName(); })),
        id: 'select',
        list_screen: list_screen,
        type: type,
    }));
};
export var refreshColumn = function (name, data, list_screen) {
    if (list_screen === void 0) { list_screen = AC.list_screen; }
    return axios.post(ajaxurl, mapDataToFormData({
        _ajax_nonce: AC._ajax_nonce,
        action: 'ac-columns',
        column_name: name,
        data: data,
        id: 'refresh',
        list_screen: list_screen,
    }));
};
